import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import { IconAirCondition, IconFridge, IconOven, IconTv } from './icons';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');

    return (
        <div className="ef-container TabA-card card-c">
            <div className="TabA-card-l">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1725851346104/pc_taba_3.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725851345919/m_taba_3.jpg"
                />
            </div>
            <div className="TabA-card-r">
                <div className="TabA-card-r-in">
                    <div className="TabA-card-title">{t('c_title')}</div>
                    <div className="TabA-card-list">
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconFridge />
                            </div>
                            <div className="TabA-card-item-text1">
                                24<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('c_item1_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconAirCondition />
                            </div>
                            <div className="TabA-card-item-text1">
                                5<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('c_item2_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconOven />
                            </div>
                            <div className="TabA-card-item-text1">
                                1<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('c_item3_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconTv />
                            </div>
                            <div className="TabA-card-item-text1">
                                5<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('c_item4_t2')}</div>
                        </div>
                    </div>
                    <div className="TabA-card-bg">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1726639175460/off_grid.png" />
                    </div>
                    <div className="TabA-card-tag">{t('c_text1')}</div>
                    <div className="TabA-card-tips">{t('c_text2')}</div>
                </div>
            </div>
        </div>
    );
}
